import { Injectable, signal } from '@angular/core';
import { ICounterparty } from '@ipnote/interface';

@Injectable()
export class CounterpartyStore {
  counterparty = signal<ICounterparty | null>(null);

  setCounterparty(value: ICounterparty | null) {
    this.counterparty.set(value);
  }

  updateCounterparty(patch: Partial<ICounterparty>) {
    const current = this.counterparty();
    if (current) {
      this.counterparty.set({ ...current, ...patch });
    }
  }
}